import "nprogress/nprogress.css";

import { ErrorHandler, NavigationGuardNext, RawLocation, Route as VueRoute } from "vue-router/types/router";
import { Events, setLocation } from "@timesheets/webapp-support";
import Router, { RouteConfig } from "vue-router";

import { IState } from "../vuex/IState";
import { PageTypes } from "./PageTypes";
import { Route } from "@gemma/utils";
import { Store } from "vuex";
import { TRouteMetaGroup } from "./TRouteMetaGroup";
import URI from "urijs";
import Vue from "vue";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { handlePages } from "./handlePages";

export function router(pageType: PageTypes, store: Store<IState>, routes?: RouteConfig[]) {
  Vue.use(Router);

  const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

  const oldPush = router.push;
  (router.push as any) = function(location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler): Promise<VueRoute | void> {
    const roleId = store && store.state && store.state.user.currentRole && store.state.user.currentRole.id;
    if (typeof location === "string") {
      const uri = new URI(location);
      const search = uri.search(true);
      if (!search.roleId && roleId) {
        uri.addSearch({ roleId });
      }
      location = uri.toString();
    } else {
      if (!location.query && roleId) {
        location.query = { roleId };
      } else if (location.query && !location.query.roleId && roleId) {
        location.query.roleId = roleId;
      }
    }

    let result: Promise<VueRoute | void> = new Promise<void>(resolve => {
      resolve();
    });

    if (router.currentRoute.fullPath !== location) {
      result = oldPush.call<Router, [RawLocation, Function | undefined, Function | undefined], Promise<VueRoute>>(router, location, onComplete, onAbort);
    }

    return result;
  };

  const resolveCorrectPage = handlePages(pageType, store);

  router.beforeEach((to: VueRoute, from: VueRoute, next: NavigationGuardNext) => {
    const toRoute = new Route<TRouteMetaGroup>(to.fullPath, undefined, to.meta as TRouteMetaGroup);
    const fromRoute = new Route<TRouteMetaGroup>(from.fullPath, undefined, from.meta as TRouteMetaGroup);
    const routeResult = resolveCorrectPage(toRoute, fromRoute);

    const routeChangedEvent = new Events.RouteChangedEvent<TRouteMetaGroup>(routeResult);
    WebApplicationConstants.listenerEventBuses.system.emit(routeChangedEvent);

    setLocation(routeResult, {
      onContinue: () => next(routeResult.route && routeResult.route.fullPath),
      onNoLocation: () => next(false),
    });
  });

  if (pageType === PageTypes.Dashboard) {
    router.afterEach(() => {
      Vue.prototype.$vueSlideout.clear();
    });
  }

  return router;
}
